import http from '@/utils/http'

// 查询项目信息列表
export function getWebsiteInfo(params) {
  return http.get(`dev-api/event/website/list`, params)
}
// 查询轮播图管理列表
export function getBannerList(params) {
  return http.get(`dev-api/event/banner/list`, params)
}
// 查询规划区列表
export function getPlanningList(params) {
  return http.get(`dev-api/event/planning/list`, params)
}
// 查询项目标段列表
export function getSectionList(params) {
  return http.get(`dev-api/event/section/list`, params)
}
// 查询施工项目列表
export function getConstruction(params) {
  return http.get(`dev-api/event/construction/list`, params)
}
// 查询项目进度列表
export function getprojectEcharts(params) {
  return http.get(`dev-api/schedule/fill/echarts/projectlist`, params)
}
// 查询施工进度统计图
export function getfillcEcharts(params) {
  return http.get(`dev-api/schedule/fill/ecarts/progresslist`, params)
}
// 查询施工计划完成统计图
export function getfillEcharts(params) {
  return http.get(`dev-api/schedule/fill/echarts/list`, params)
}


